import { render } from "./MobileDefaultLayout.vue?vue&type=template&id=575f8072"
import script from "./MobileDefaultLayout.vue?vue&type=script&lang=js"
export * from "./MobileDefaultLayout.vue?vue&type=script&lang=js"

import "./MobileDefaultLayout.vue?vue&type=style&index=0&id=575f8072&lang=css"

import exportComponent from "../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__